import React from 'react';
import './Copies.scss';

function Copy1() {
  return (
    <section className="copies copy1">
      <p className="copies__copy">
        When her infant son developed little rough patches on his skin, Ellen Buchanan Weiss, an
        activist and silversmith based in Raleigh, North Carolina, did what most parents would do:
        she Googled it. But instead of finding helpful images to compare to her son’s mixed-race
        skin, all Buchanan Weiss found online were photos of Caucasian skin.
      </p>
      <p className="copies__copy">
        “I Googled ‘eczema,’ and noticed right away that there were no reference pictures for
        children of color,” she says.
        <sup className="copies__copy--sup">1</sup>
      </p>

      <p className="copies__copy">
        Her son was eventually diagnosed with atopic dermatitis, or eczema, but Ellen was left
        feeling that she should do something about the lack of representation in medical reference
        photos. This frustration led her to start the Instagram account{' '}
        <a
          className="copies__link"
          href="https://www.instagram.com/brownskinmatters/?hl=en"
          target="_blank"
          rel="sponsored"
        >
          Brown Skin Matters
        </a>{' '}
        to provide other parents with the images they might need. Just three years after starting
        Brown Skin Matters, the account has more than 32,000 followers. It’s even garnered a
        following among physicians, dermatology students, and various other medical professionals.
      </p>
      <p className="copies__copy">
        It’s not just internet photos that lack diversity. A{' '}
        <a
          className="copies__link"
          href="https://www.jaad.org/article/S0190-9622(20)30700-3/pdf"
          target="_blank"
          rel="sponsored"
        >
          recent analysis
        </a>{' '}
        published in the{' '}
        <span className="italic">Journal of the American Academy of Dermatology</span> found that
        only 4% to 18% of images in textbooks for dermatology medical students include dark skin.
        <sup className="copies__copy--sup">2</sup> This disparity can lead to incomplete medical
        training and biases in healthcare, especially when it comes to diagnosing common issues like
        eczema. Without education on a full spectrum of skin tones, dermatologists could find it
        more difficult to properly diagnose patients of color.
      </p>
      <p className="copies__copy">
        This potential systemic issue in dermatology (and healthcare) affects millions worldwide,
        with eczema being one of the most common medical conditions.
        <sup className="copies__copy--sup">3</sup> However, there are people—most notably patients
        and dermatologists—working on solutions, support, and awareness across the healthcare system
        and around the world.
      </p>
    </section>
  );
}

export default Copy1;
